import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faUserClock } from '@fortawesome/pro-solid-svg-icons/faUserClock'
import Button from '@softwaredev_cegeka/stix-core/dist/components/Button'
import Modal from '@softwaredev_cegeka/stix-modal/dist/components/Modal'
import withNotifier from '@softwaredev_cegeka/stix-notifier/dist/components/withNotifier'
import useTranslations from 'src/hooks/useTranslations'
//Style
import styles from './sessionExpiredModal.module.scss'

SessionExpiredModal.propTypes = {
    sessionExpired: PropTypes.bool,
    onLoginClick: PropTypes.func,
}

SessionExpiredModal.defaultProps = {
    sessionExpired: false,
}

function SessionExpiredModal(props) {
    const { onLoginClick, sessionExpired, notifier } = props
    const [showModal, setShowModal] = useState(sessionExpired)
    const { t } = useTranslations('SessionExpired', 'SessionExpired')

    useEffect(() => {
        setShowModal(sessionExpired)
    }, [sessionExpired])

    function continueHandler() {
        setShowModal(!showModal)
        const snackbarId = notifier.addSnackbarMessage(
            <>
                <span className={styles.snackbarTitle}>
                    {t('Your session has expired.')}
                </span>
                <span className={styles.snackbarContent}>
                    {t('Please login again to continue.')}
                </span>
            </>,
            {
                autoHide: false,
                canClose: false,
                ActionComponent: () => (
                    <Button
                        variant="secondary"
                        onClick={() => {
                            notifier.deleteSnackbarMessage(snackbarId)
                            onLoginClick()
                        }}
                    >
                        {t('Log in')}
                    </Button>
                ),
            }
        )
    }

    function loginHandler() {
        setShowModal(!showModal)
        onLoginClick()
    }

    return (
        <Modal
            show={showModal}
            onHide={continueHandler}
            centered
            dialogClassName={styles.dialog}
        >
            <Modal.Header closeButton />
            <Modal.Body>
                <span className={styles.iconWrapper}>
                    <FontAwesomeIcon icon={faUserClock} />
                </span>
                <h1 className={styles.title}>
                    {t('Your session has expired')}
                </h1>
                <p className={styles.content}>
                    {t('Please login again to continue')}
                </p>
            </Modal.Body>
            <Modal.Footer align={'left'}>
                <Button
                    variant="secondary"
                    onClick={loginHandler}
                    className={styles.loginBtn}
                >
                    {t('Log in')}
                </Button>
                <Button
                    variant="ghost"
                    className={styles.cancelLink}
                    onClick={continueHandler}
                >
                    {t('Dismiss')}
                </Button>
            </Modal.Footer>
        </Modal>
    )
}

export default withNotifier(SessionExpiredModal)
